import React from 'react'
import styled from 'styled-components'
import noContentImage from './no-content.png'

const Wrapper = styled.div`
  background: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  color: #383838;
  font-size: 11.2rem;
  font-weight: bold;
  align-items: center;
  justify-content: center;

  img {
    width: 18.6rem;
    height: 26.5rem;
    margin-bottom: 4rem;
  }
`

const NoContent = () => (
  <Wrapper>
    <img src={noContentImage} alt="no content"/>
  </Wrapper>
)

export default NoContent
